import { Datas } from './datas';

export class Colaboradores{
    Ativos:number;
    Pendentes:number;
    DataColaboradores:Datas;
    Ferias:number;
    QuantidadeFuncionario:number;
}